import { controls,grouped } from "../controls";
const account_insurances = {
label: "Account Insurances",
pageLabel: "Account Insurances",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "Insurance Company Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "insurance_company_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Insurance Type Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "insurance_type_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Policy Number"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "policy_number",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "filter", label: "Policy Start Date",target: "policy_start_date"}),
...controls.magicDate({ tab: "filter", name: "policy_start_date", dateType: "ontype" }),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "filter", label: "Policy End Date",target: "policy_end_date"}),
...controls.magicDate({ tab: "filter", name: "policy_end_date", dateType: "ontype" }),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Insured Amount"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "insured_amount",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Premium Amount"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "premium_amount",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
]
,form:[
...controls.displayText({ tab: "general", label: "Insurance Company",star:true}),
...controls.autoComplete({tab: "general", name: "insurance_company_code", width: "col-sm-2",controlType: "InsuranceCompany"}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Insurance Type",star:false}),
...controls.autoComplete({tab: "general", name: "insurance_type_code", width: "col-sm-2",controlType: "InsuranceType"}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Policy Number",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "policy_number",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "general", label: "Policy Start Date",target: "policy_start_date",star:false}),
...controls.magicDate({ tab: "general", name: "policy_start_date", dateType: "ontype" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "general", label: "Policy End Date",target: "policy_end_date",star:false}),
...controls.magicDate({ tab: "general", name: "policy_end_date", dateType: "ontype" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Insured Amount",star:true}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "insured_amount",isRequired:true,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Premium Amount",star:true}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "premium_amount",isRequired:true,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
]
,history:{
perPage: 10,
reportHeader: "Account Insurances",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Insurance Company Id",accessor: "insurance_company_id",},
{Header: "Insurance Type Id",accessor: "insurance_type_id",},
{Header: "Policy Number",accessor: "policy_number",},
{Header: "Policy Start Date",accessor: "policy_start_date",type:'date'},
{Header: "Policy End Date",accessor: "policy_end_date",type:'date'},
{Header: "Insured Amount",accessor: "insured_amount",},
{Header: "Premium Amount",accessor: "premium_amount",},
]}};
export default account_insurances;